import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var AssetFolderIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,5l0,-2c0,0 3.384,0 6.002,0c0.795,0 1.558,0.316 2.12,0.878c0.319,0.32 0.559,0.704 0.707,1.122l2.67,0c1.382,0.001 2.501,1.121 2.501,2.501l0,4.998c0,1.38 -1.119,2.5 -2.501,2.501l-11.499,0l0,-10ZM13.412,7l-9.412,0c0,0.124 0.017,6 0,6c0.673,-0.018 2,-5 2,-5l8,-0.412c0,-0.323 -0.261,-0.585 -0.588,-0.588Z"
  }));
});
AssetFolderIcon.displayName = 'AssetFolderIcon';
export default AssetFolderIcon;